(function($) {
    
    const customFileInput = document.querySelectorAll('.custom-file-input')
    
    if(customFileInput) {
        
        customFileInput.forEach(el => {
            const input = el.querySelector('input[type="file"]')
            const button = el.querySelector('.file-button')
            const content = el.querySelector('.file-content')
            const text = el.querySelector('.file-name')
            const defaultText = text.innerText
            
            const form = el.closest('form')
            
            const clearInput = document.createElement('button')
            clearInput.classList.add('remove-file')
            clearInput.innerHTML = "Remover"
            clearInput.type = 'button'
            
            input.setAttribute('tabindex', '-1')
            
            button.addEventListener('click', () => input.click())
            
            function clear() {
                input.value = ''
                text.innerHTML = defaultText ? defaultText : 'Nenhum arquivo selecionado'
                
                clearInput.remove()
            }
            
            form.addEventListener('wpcf7invalid', event => {
                const fieldName = input.name
                const fieldError = 
                    event && event.detail && event.detail.apiResponse && event.detail.apiResponse.invalid_fields
                    ? event.detail.apiResponse.invalid_fields.find(el => el.field === fieldName)
                    : null
                
                if(fieldError) {
                    alert(`Erro ao enviar arquivo: ${fieldError.message}`)
                }
            })
            
            form.addEventListener('wpcf7mailsent', () => clear())
            clearInput.addEventListener('click', () => clear())
            
            input.addEventListener('change', function() {
                if(this.files.length) {
                    const textValue = this.files.length > 1 
                        ? `${this.files.length} arquivos escolhidos` 
                        : this.files[0].name
                        
                    text.innerHTML = textValue
                    content.appendChild(clearInput)
                        
                    return
                }
                
                clear()
            })
        })
    }

})(jQuery);
(function($) {
    
    document.addEventListener('DOMContentLoaded', function () {
        const tableContent = document.querySelectorAll('.table-container');
        
        tableContent.forEach(ele => {
            ele.style.cursor = 'grab';
        
            let pos = { top: 0, left: 0, x: 0, y: 0 };
        
            const mouseDownHandler = function (e) {
                ele.style.cursor = 'grabbing';
                ele.style.userSelect = 'none';
        
                pos = {
                    left: ele.scrollLeft,
                    top: ele.scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };
        
                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };
        
            const mouseMoveHandler = function (e) {
                // How far the mouse has been moved
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;
        
                // Scroll the element
                ele.scrollTop = pos.top - dy;
                ele.scrollLeft = pos.left - dx;
            };
        
            const mouseUpHandler = function () {
                ele.style.cursor = 'grab';
                ele.style.removeProperty('user-select');
        
                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
            };
        
            // Attach the handler
            ele.addEventListener('mousedown', mouseDownHandler);
        })
        
    });
    
})(jQuery);
(function($) {
    const enderecosContainer = $('.enderecos-container')
    const enderecosSwitch = $('.enderecos-switch')
    let sliderInstance = null
    
    if(enderecosContainer.length) {
        sliderInstance = enderecosContainer.slick({
            arrows: false,
            fade: true,
            adaptiveHeight: true,
            swipe: false,
            touchMove: false,
            accessibility: false,
            draggable: false,
        })
    }
    
    if(enderecosSwitch.length) {
        enderecosSwitch.on('click', function() {
            enderecosSwitch.each(function() {
                $(this).removeClass('active')
            })
            
            $(this).addClass('active')
            
            const index = $(this).index()
            
            sliderInstance.slick('slickGoTo', index)
        })
    }
})(jQuery);
(function($) {
    // Menu
    function menuToggle(e) {
        $('.mobile-menu-button').toggleClass('open');
        $('.main-navbar').toggleClass('open');
        $('body').toggleClass('no-scroll');
    }
    $('.mobile-menu-button').on('click', menuToggle);
    
    function submenuToggle(e) {
      
      const isMobile = window.innerWidth < 1200
      
      if (!isMobile) {
        return;
      }
      
      e.preventDefault()
      
      if ( $( $(this).attr('href') ).length ) {
        menuToggle();
        closeMenuOnClick();
        return;
      }
      
      $(this).parent().toggleClass('active');
      let submenu = $(this).next('ul');
      
      if ($(this).parent().hasClass('active') && submenu.length) {
        submenu.height( submenu.prop("scrollHeight") );
      } else {
        submenu.height( 0 );
      }
    }
    $('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);
    
    function closeMenuOnClick(event) {
      if(!$(event.target).parent().hasClass('menu-item-has-children')) {
        menuToggle();
      }
    }
    $('.main-navbar a').on('click', function(e) {
      if(window.matchMedia('(max-width: 1200px)').matches) {
        closeMenuOnClick(e)
        return
      }
    })
    $('footer a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });
    
    // Smooth scroll and dynamic target
    const anchorLinks = document.querySelectorAll('.navbar li > a[href*="#"], .footer-navbar li > a[href*="#"]')
    
    anchorLinks.forEach(link => {
  		link.addEventListener('click', function (event) {
  			const targetLink = new URL(this.href)
  			const currentLink = new URL(window.location.href)
  			
  			const targetPath = targetLink.pathname.split('/').filter(path => path)
  			const currentPath = currentLink.pathname.split('/').filter(path => path)
  			
  			const isSamePath = 
  			    targetPath.length === currentPath.length &&
  			    targetPath.every((element, index) => element === currentPath[index])
        
  			if(!isSamePath) return
  			
  			event.preventDefault()
  			
  			const hash = targetLink.hash
  			const targetElement = document.querySelector(hash)
  			const isMobile = window.innerWidth < 1200
  			const hasChildItem = this.parentElement.classList.contains('menu-item-has-children')
  			
  			if(!targetElement) return
              
  			if (isMobile && hasChildItem) return
  			
  			window.scrollTo({
  				top: targetElement.offsetTop - (window.innerHeight * 0.10),
  				behavior: 'smooth'
  			})
  		})
  	})

})(jQuery);
(function($) {
    
    class roundedImagesGallery {
        constructor(container = null) {
            this.container = container
            this.button = this.container.querySelector('.toggle-button')
            
            if(!this.container) return
            if(!this.button) return
            
            this.mainImages = this.container.querySelectorAll('.main-image-container a')
            this.buttonImages = this.button.querySelectorAll('img')
            
            if(this.mainImages.length <= 1) return
            
            this._init()
        }
        
        _init() {
            this.button.addEventListener('click', () => {
                this._toggleImages()
            })
        }
        
        _toggleImages() {
            const nextIndex = +this.button.dataset.next
            const nextMainImage = this.mainImages[nextIndex]
            const updatedDataValue = nextIndex + 1 <= this.mainImages.length - 1 ? nextIndex + 1 : 0
            const nextButtonImage = this.buttonImages[updatedDataValue]
            const nextButtonText = nextButtonImage.dataset.text
            
            this.buttonImages.forEach(el => el.classList.remove('current'))
            this.mainImages.forEach(el => {
                el.classList.remove('current')
                el.setAttribute('tabindex', '-1')
            })
            
            nextButtonImage.classList.add('current')
            nextMainImage.classList.add('current')
            nextMainImage.setAttribute('tabindex', '0')
            
            this.button.querySelector('span').innerHTML = nextButtonText
            
            this.button.dataset.next = updatedDataValue
        }
    }
    const imageContainer = document.querySelector('.inicio .sobre .image-container')
    if(imageContainer) new roundedImagesGallery(imageContainer)
    
    class customModal {
        constructor(section = null) {
            this.html = document.querySelector('html')
            
            this.section = section
            this.trigger = this.section.querySelectorAll('.modal-trigger')
            this.modal = this.section.querySelector('.modal-container')
            
            this.selectContent = this.modal.querySelector('select')
            this.closeButton = this.modal.querySelector('.modal-close-button')
            this.optionContent = Array.from(this.modal.querySelectorAll('.option-content'))
            
            this.selectableQuery = 'a[href]:not([tabindex="-1"]), area[href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), button:not([tabindex="-1"]), iframe:not([tabindex="-1"]), object:not([tabindex="-1"]), embed:not([tabindex="-1"]), *[tabindex]:not([tabindex="-1"]), *[contenteditable]:not([tabindex="-1"])'
            this.documentFocusableItems = document.querySelectorAll(this.selectableQuery)
            this.modalFocusableItems = this.modal.querySelectorAll(this.selectableQuery)
            
            this._init()
        }
        
        _init() {
            this.trigger.forEach(button => {
                button.addEventListener('click', (event) => {
                    event.stopPropagation()
                    const contentTarget = event.currentTarget.dataset.content
                    
                    if(!contentTarget) return 
                    
                    this._open(contentTarget)
                })
            })
            
            this.selectContent.addEventListener('change', () => {
                this._update(this.selectContent.value)
            })
            
            document.addEventListener('keydown', event => {
                if(event.key == 'Escape') this._close()
            })
            
            this.closeButton.addEventListener('click', () => this._close())
            
            this.modal.addEventListener('click', event => {
                if(event.target === event.currentTarget) this._close()
            })
        }
        
        _open(target) {
            this.html.classList.add('no-scroll')
            this.modal.classList.add('active')
            this._update(target)
            this._toggleTabIndex()
        }
        
        _close() {
            this.html.classList.remove('no-scroll')
            this.modal.classList.remove('active')
            this._toggleTabIndex(false)
        }
        
        _update(content = null) {
            if(!content) return
            
            this.selectContent.value = content
            
            this.optionContent.map(el => {
                if(el.id !== content) {
                    el.classList.remove('active')
                    
                    return
                }
                
                el.classList.add('active')
            })
        }
        
        _toggleTabIndex(trap = true) {
            this.documentFocusableItems.forEach(el => el.setAttribute('tabindex', trap ? '-1' : '0'))
            this.modalFocusableItems.forEach(el => el.setAttribute('tabindex', trap ? '0' : '-1'))
        }
    }
    
    const responsabilidadeAmbiental = document.querySelector('.inicio .responsabilidade-ambiental')
    if(responsabilidadeAmbiental) new customModal(responsabilidadeAmbiental)
    
})(jQuery);
jQuery(document).ready(function () {
  jQuery(".content-container").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    initialSlide: 2,
    accessibility: false,
    adaptiveHeight: true,
    draggable: false,
    focusOnSelect: false,
    initialSlide: 0,
    mobileFirst: false,
    swipe: false,
    touchMove: false,
  });

  jQuery(".main-image").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    draggable: false,
    focusOnSelect: false,
    swipe: false,
    touchMove: false,
    asNavFor: ".image-selector",
  });

  jQuery(".image-selector").slick({
    centerMode: true,
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "ondemand",
    dots: true,
    variableWidth: true,
    asNavFor: ".main-image",
    focusOnSelect: true,
    swipe: true,
    touchMove: true,
  });

  jQuery(".processos-container").slick({
    slidesToScroll: 1,
    arrows: false,
    lazyLoad: "ondemand",
    variableWidth: true,
    focusOnSelect: true,
    swipe: false,
    touchMove: true,
    asNavFor: ".processos-conteudo",
  });

  jQuery(".processos-conteudo").slick({
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    lazyLoad: "ondemand",
    prevArrow: jQuery(".etapas-prev"),
    nextArrow: jQuery(".etapas-next"),
    asNavFor: ".processos-container",
    adaptiveHeight: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 639,
        settings: {
          adaptiveHeight: false,
        },
      },
    ],
  });

  jQuery(".chapas").each(function () {
    currentType = jQuery(this).attr("data-name");

    jQuery(`.img-${currentType}`).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      fade: true,
      initialSlide: 0,
      accessibility: false,
      adaptiveHeight: true,
      draggable: false,
      focusOnSelect: false,
      mobileFirst: false,
      swipe: false,
      touchMove: false,
      prevArrow: jQuery(`.prev-${currentType}`),
      nextArrow: jQuery(`.next-${currentType}`),
    });
  });
});

// Show to top

function topButton() {
  const windowScroll = jQuery(window).scrollTop();
  const button = jQuery('#floating');

  if (windowScroll >= 450) {
    button.addClass('show');
  } else {
    button.removeClass('show');
  }
}

jQuery(document).scroll(() => {
  topButton();
});


jQuery(document).ready(() => {
  topButton();
});
(function($) {
    
    // Mapa
    const mapa = document.querySelectorAll('.map')
    
    if(mapa) {
        mapa.forEach(el => {
            
            let coordinates = el.dataset.coordinates;
            
            if (!coordinates) {
                return;
            }
            
            coordinates = JSON.parse(coordinates.replaceAll('\'', '"'));
            
            let sumX = 0;
            let sumY = 0;
            let count = 0;
            let feature = [];
            coordinates.forEach(function (currentValue, index) {
                sumY += parseFloat(currentValue[0]);
                sumX += parseFloat(currentValue[1]);
                count++;
                
                feature.push(
                    new ol.Feature({
                        name: 'Qualiplás ' + index++,
                        geometry: new ol.geom.Point(ol.proj.fromLonLat(currentValue))
                    })
                );
            });
            const avgX = sumX / count;
            const avgY = sumY / count;
            const centerPosition = [avgY, avgX];
            
            new ol.Map({
                target: el,
                controls: ol.control.defaults({ attribution: false }),
                interactions: ol.interaction.defaults({mouseWheelZoom: false}),
                layers: [
                    new ol.layer.Tile({
                        title: 'Qualiplás',
                        className: 'bw',
                        source: new ol.source.OSM()
                    }),
                    new ol.layer.Vector({
                        source: new ol.source.Vector({
                            className: 'icon',
                            features: feature
                        }),
                        style: new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: [0.5, 1],
                                anchorXUnits: 'fraction',
                                anchorYUnits: 'fraction',
                                scale: 1,
                                src: el.dataset.marker
                            })
                        })
                    }),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat(centerPosition),
                    zoom: 16
                })
            });
        })
    }
    
})(jQuery);
(function($) {
    
    const sliderVariacoes = document.querySelectorAll('.single-produtos .variacoes .gallery-container')
    
    sliderVariacoes.forEach(container => {
        const wrapper = container.querySelector('.gallery-wrapper')
        const prev = container.querySelector('.prev')
        const next = container.querySelector('.next')
        
        $(wrapper).slick({
            accessibility: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: prev,
            nextArrow: next,
            infinite: false,
        })
    })
    
})(jQuery);
(function($) {
	
	const profissionais = $('.page-sobre .galeria .slider-container');
	
	if (profissionais.length) {
			
		profissionais.each(function() {
			const container = $(this)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
				arrows: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 993,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							dots: false,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
	}

})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				// button.setAttribute('disabled', true)
				button.classList.add('loading')
			})
		
			form.addEventListener('wpcf7submit', function() {
				const button = this.querySelector('button[type=submit]')
				
				button.removeAttribute('disabled')
				button.classList.remove('loading')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
    // Mask date inputs
    $('input.custom-date').mask('00/00/0000')
    
})(jQuery);